<template lang="pug">
  login
</template>

<script>
import Login from '@/components/login/tApp.vue'
export default {
  name: 'App',
  components: { Login },
  beforeCreate() {
    document.title = window.ConfigNew.header.title
  }
}
</script>
<style lang="css">
@import url('../src/ui/css/ui.css');
</style>



// WEBPACK FOOTER //
// src/tApp.vue